module.exports = __webpack_public_path__ + "static/media/refund-inactive.f54e6988.svg";